<template>
<div class="chapter">
<div class="inner_page">
<p class="title"><a id="page_i"></a><span class="small">THE</span><br/>DEESIDE<br/>WAY</p>
<p class="author"><em>Peter Evans</em></p>
<p class="image-pub"><img alt="Illustration" src="images/pub.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?ebcc051e